export default __webpack_public_path__ + "static/media/backerkit.3499fbd1.svg";